import React from 'react'

import Breadcrumbs from './Breadcrumbs'

function PageHeader({ title, active, progress, handleLogoClick }) {
  return (
    <header className='pt-2'>
      <div className="container">
        <div className="row justify-content-between">
          <div className="col-3">
            <div onClick={handleLogoClick}>
              <img src={require(`../assets/images/logo.png`)} alt="Guerin" className="img-fluid pt-3 pb-3" />
            </div>
          </div>
          <Breadcrumbs
            title={title}
            active={active}
            progress={progress}
          />
        </div>
      </div>
    </header>
  )
}

export default PageHeader